import type { JSX } from 'react'
import { Chip, Button, Stack } from '@mui/material'
import type { ToolUi } from '../runtime/types'

/**
 * Renders a label Chip for a tool side-effect.
 * If the chip is a `steer` kind AND `onUndo` is provided, an Undo button is shown alongside.
 */
export function ToolChip({
  chip,
  onUndo,
}: {
  chip: Extract<ToolUi, { kind: 'chip' } | { kind: 'steer' }>
  onUndo?: (ui: Extract<ToolUi, { kind: 'steer' }>) => void
}): JSX.Element {
  const handleUndo = () => {
    if (chip.kind === 'steer' && onUndo) {
      onUndo(chip)
    }
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ display: 'inline-flex' }}>
      <Chip label={chip.label} size="small" variant="outlined" />
      {chip.kind === 'steer' && onUndo !== undefined && (
        <Button size="small" variant="text" onClick={handleUndo}>
          Undo
        </Button>
      )}
    </Stack>
  )
}
